import { FC, MouseEventHandler, useCallback, useState } from 'react';
import AnimateHeight from 'react-animate-height';

import styles from './ReadMore.module.scss';

// TODO: Merge with other ReadMore

const TRANSLATIONS = {
  en: {
    readLess: 'Close',
    readMore: 'Read More',
  },
  ja: {
    readLess: '閉じる',
    readMore: 'もっと読む',
  },
};
const MAX_LENGTH_EN = 125;
const MAX_LENGTH_JA = 61;
const MESSAGE_MIN_HEIGHT = 70;
const ANSWER_MIN_HEIGHT = 140;

function isMessageLengthWithinThreshold(language: string, length?: number): boolean {
  if (length) {
    switch (language) {
      case 'en':
        return length <= MAX_LENGTH_EN;

      default:
        return length <= MAX_LENGTH_JA;
    }
  }
  return false;
}

interface Props {
  language: 'en' | 'ja';
  message?: string;
}

const ReadMore: FC<Props> = ({ language, message, children }) => {
  const height = children ? ANSWER_MIN_HEIGHT : MESSAGE_MIN_HEIGHT;

  const [expanded, setExpanded] = useState(
    isMessageLengthWithinThreshold(language, message?.length)
  );
  const [shouldShowLessButton, setShouldShowLessButton] = useState(false);

  const handleExpand = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    // Prevent navigation of parent anchor element
    event.preventDefault();
    event.stopPropagation();
    setExpanded((value) => !value);
    setShouldShowLessButton((value) => !value);
  }, []);

  return (
    <div className={styles['message-container']}>
      <AnimateHeight duration={300} height={expanded ? 'auto' : height}>
        {children ?? <p>{message}</p>}
        {shouldShowLessButton && (
          <button onClick={handleExpand} className={styles['read-less']}>
            {TRANSLATIONS[language].readLess}
          </button>
        )}
      </AnimateHeight>
      {!expanded && (
        <button onClick={handleExpand} className={styles['read-more']} data-test-id="read-more">
          {TRANSLATIONS[language].readMore}
        </button>
      )}
    </div>
  );
};

export default ReadMore;
export type { Props as ReadMoreProps };
